<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Update Budget Report</h5>
  </div>
<div id="mainContent" class="container">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Financial Year<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedFinancialYear"
              >
                <option value="">Select Year</option>
                <option *ngFor="let finance of financialList" [ngValue]="finance">
                  {{ finance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
  
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label"
              >Partner<span class="text-danger">*</span></label
            >
            <div class="col-sm-6">
              <select
                class="form-control form-control-xs mt-1"
                [(ngModel)]="selectedEmployee"
              >
                <option value="">Select Partner</option>
                <option
                  *ngFor="let employee of employeeList"
                  [ngValue]="employee"
                >
                  {{ employee.firstName }} {{ employee.middleName }}
                  {{ employee.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
  
      <div class="row mt-3">
          <div class="col-sm-5">
           <div class="row">
            <div class="col-sm-4">
              <label>Upload File</label>
            </div>
            <div class="col-sm-6">
              <input
                #file
                type="file"
                accept="image/*,.doc, .docx,.ppt,.pptx,.txt,.pdf,.xlsx,.rtf,.xls,video/mp4,video/x-m4v,video/*,audio/mp3,audio/ogg,audio/mp4"
                placeholder="Upload file"
                (change)="fileChange($event)"
                [(ngModel)]="selectedFile"
              />
            </div>
            <!-- <div class="col-sm-4">
              <a
                href="{{ editDocumnetURL }}"
                target="_blank"
                rel="noopener noreferrer"
              >
             
                <span>{{ editDocumentName }}</span>
              </a>
            </div> -->
        </div>
    </div>

        <div class="col-sm-2">
          <button
            type="button"
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="onUpdateBudgetReport()"
          >
            Update Report
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>